import { Box, ClickAwayListener, Tooltip, Typography } from '@mui/material';
import React from 'react';

const InfoTooltip = ({ openToolTip, setOpenToolTip, text }) => {
  const handleToolTip = () => {
    setOpenToolTip((curr) => {
      return !curr;
    });
  };
  return (
    <ClickAwayListener onClickAway={() => setOpenToolTip(false)}>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: 'common.white',
              color: 'common.black',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)', // Dodavanje box-shadow efekta
              mr: '5px',
              // marginRight: '10px',
            },
          },
        }}
        PopperProps={{
          disablePortal: true,
        }}
        placement="bottom"
        onClose={() => setOpenToolTip(false)}
        open={openToolTip}
        // arrow
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={
          <Box component="span" p={1} width="300px">
            <Typography my={2} sx={{ whiteSpace: 'pre-wrap' }}>
              {text}
            </Typography>
            {/* <FormControlLabel label={text} /> */}
          </Box>
        }
      >
        <i
          style={{
            fontSize: '20px',
            // position: 'absolute',
            // right: '4px',
            // top: '4px',
            color: '#ed8448',
          }}
          className="fas fa-info-circle"
          onClick={handleToolTip}
        />
      </Tooltip>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
